// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1__c1994187b1d0c5c1e785","cls2":"Header-cls2___08902676fab87ee5d08 Header-cls1__c1994187b1d0c5c1e785"};